export default __webpack_public_path__ + "5dd8d79666b37f71a8791e62c339ceac.jpg";